export default "__VITE_ASSET__BbcWe2yu__"